import axios from '@/server/request'
import { Message } from 'element-ui'

const state = {
    // 素材分类列表
    materialCategoryData: {},
    isMaterialCategoryLoading: true
}

const mutations = {
    updateMaterialCategory(state, payload) {
        state.materialCategoryOptions = null
        state.materialCategoryData = payload
    },

    updateMaterialCategoryLoaing(state, payload) {
        state.isMaterialCategoryLoading = payload
    }
}

const actions = {
    // 素材分类列表
    async fetchMaterialCategory({ commit }, params) {
        commit('updateMaterialCategoryLoaing', true)
        try {
            const res = await axios.get({
                url: '/materialcategory/list',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateMaterialCategory', res.data.Data)
                commit('updateMaterialCategoryLoaing', false)
                return Promise.resolve()
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateMaterialCategoryLoaing', false)
        }
    },

    // 添加到素材分类
    async addToMaterialCategory({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/materialcategory/add',
                params
            })
            if (res.data.ErrorCode === 200) {
                Message({
                    message: '添加成功',
                    type: 'success'
                })
                return Promise.resolve()
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 移动至素材分类
    async moveToMaterialCategory({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/material/move',
                params
            })

            if (res.data.ErrorCode === 200) {
                Message({
                    message: '添加成功',
                    type: 'success'
                })
                return Promise.resolve()
            } else {
                // 抛出错误信息用于根据重复素材ID，友好提示用户
                return Promise.reject(res.data)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 添加到素材库
    async addToMaterial({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/material/addMaterial',
                params
            })

            if (res.data.ErrorCode === 200) {
                return Promise.resolve()
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(new Error(res.data.ErrorMessage))
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions
}
